function BaseController($scope, $location,  $timeout, $rootScope, $state, $q, GeneralUtilsService, $transitions, $filter, $sce, UserContextService, CopyToClipboardService) {
    /* globals zE $zopim shouldSendStats ga */
    $scope.Math = Math;

    $rootScope.errors = {};

    $scope.isEditorRoleUser = function() {
        return UserContextService.isEditor();
    }

    $scope.getAdminEmail = function() {
        return UserContextService.getEmail();
    }

    $scope.isRedInitials = function() {
        return !UserContextService.isDisableGUI() && isSystemLogin;
    }

    $scope.isEditionDisabled = function() {
        return UserContextService.isDisableGUI() || (UserContextService.isSystemLogin() && !UserContextService.isSystemAdminElevatedForAccount($state.params.accountId));
    }

    $scope.changeFromViewerToEditorRole = function(codeForRoleElevation) {
        store.action({
            path: '/changeFromViewerToEditorRole',
            queryParams: {
                accountId: $state.params.accountId,
                code: codeForRoleElevation
            },
            success: function (data) {
                $scope.$root.handleServerResponse(data, "" , 'Editor permissions applied');
                $scope.$digest();
            },
        });
    }

    $scope.changeFromViewerToEditorRoleForAdminArea = function(codeForRoleElevation) {
        store.action({
            path: '/changeFromViewerToEditorRole',
            queryParams: {
                accountId: '1',
                code: codeForRoleElevation
            },
            success: function (data) {
                $scope.$root.handleServerResponse(data, "" , 'Editor permissions applied');
                $scope.$digest();
            },
        });
    }

    $scope.changeFromEditorToViewerRole = function() {
        store.action({
            path: '/changeFromEditorToViewerRole',
            queryParams: {
                accountId: $state.params.accountId
            },
            success: function (data) {
                $scope.$root.handleServerResponse(data, "" , 'Editor permissions revoked');
                $scope.$digest();
            },
        });
    }

    /**
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     */
    $scope.detectIE = function() {
        var ua = window.navigator.userAgent;

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    };

    // Get IE or Edge browser version
    $rootScope.ieVersion = $scope.detectIE();

    function sumElWidth(el, contentSettings, calcWidth) {
        if (calcWidth) contentSettings.contentWidth += parseInt($(el.parentElement).width(), 10);
        contentSettings.contentText += ' ' + el.data;
    }

    function calculateSpan(elements, contentSettings) {
        elements.forEach(function (el) {
            var children = el.childNodes;
            if (children.length === 0) {
                if (el.nodeType === Node.TEXT_NODE) {
                    sumElWidth(el, contentSettings);
                }
            } else {
                var cleanChildren = []; // no comments nodes
                for (var i = 0; children[i]; i++) {
                    if (children[i].nodeType !== Node.COMMENT_NODE) {
                        cleanChildren.push(children[i]);
                    }
                }

                if (cleanChildren.length === 1) {
                    if (cleanChildren[0].nodeType === Node.TEXT_NODE) {
                        sumElWidth(cleanChildren[0], contentSettings, true);
                        return;
                    }
                }

                calculateSpan(cleanChildren, contentSettings);
            }
        });
    }

    function setEllipsis(event) {
        var $wrapper = $(event.currentTarget);
        var $content,
            contentSettings = {
                contentWidth: 0,
                contentText: '',
            };
        if (event.target.tagName === 'TD') {
            $content = $wrapper.find('table-cell').filter(':first');
        } else {
            $content = $wrapper.children('span');
        }

        if ($content.length > 0) {
            calculateSpan($content.toArray(), contentSettings);
        } else {
            contentSettings.contentWidth = $content.width();
            contentSettings.contentText = $content.html();
        }

        if ($wrapper.width() < contentSettings.contentWidth) {
            showHover($wrapper, contentSettings.contentText, 'ellipses');
        }
    }

    function clearRootScopeKey(event) {
        $scope.$apply(function () {
            $rootScope[event.data] = null;
        });
    }

    function setCatoTooltip(event) {
        var $tooltipEl = $(event.currentTarget);
        showHover($tooltipEl, $tooltipEl.attr('data-title'), 'tooltip', $tooltipEl.attr('data-type'));
    }

    function showNotImplementedHover(event) {
        showHover($(event.currentTarget), 'This data in not available when using this connection type', 'ellipses');
    }

    function setHoverHandlers() {
        var $elementJQ = $('.top-content');

        $elementJQ.on('mouseenter', '.ellipsis', setEllipsis);
        $elementJQ.delegate('.ellipsis', 'mouseleave', 'ellipses', clearRootScopeKey);

        $elementJQ.on('mouseenter', '.cato-tooltip', setCatoTooltip);
        $elementJQ.delegate('.cato-tooltip', 'mouseleave', 'tooltip', clearRootScopeKey);

        $elementJQ.on('mouseenter', '.not-implemented', showNotImplementedHover);
        $elementJQ.delegate('.not-implemented', 'mouseleave', 'ellipses', clearRootScopeKey);
    }

    function clearHoverHandlers() {
        var $elementJQ = $('.top-content');

        $elementJQ.off('mouseenter', '.ellipsis', setEllipsis);
        $elementJQ.off('.ellipsis', 'mouseleave', clearRootScopeKey);

        $elementJQ.off('mouseenter', '.cato-tooltip', setCatoTooltip);
        $elementJQ.off('.cato-tooltip', 'mouseleave', clearRootScopeKey);

        $elementJQ.off('mouseenter', '.not-implemented', showNotImplementedHover);
        $elementJQ.off('.not-implemented', 'mouseleave', clearRootScopeKey);
    }

    $scope.getError = function (notification, type) {
        if (typeof $scope.specialErrorHandle === 'function') {
            $scope.specialErrorHandle(notification);
        }
        var notificationMessage = notification.message;
        var globalNotification = true;
        var message;

        if (notification.field) {
            var field;
            if (notification.field.indexOf('.') == 0) {
                // starts with dot
                field = type + notification.field;
            } else {
                field = notification.field.replace('model.', type.toLowerCase() + '.').replace('fromJSON.', type + '.');
            }
            notificationMessage = notificationMessage.trim();
            if (notificationMessage.indexOf('.', notificationMessage - 1) == -1) {
                notificationMessage += '.';
            }

            globalNotification = false;

            var $targetField = $('[data-id="' + field + '"]');

            if ($targetField.length > 0) {
                $rootScope.errors[field] = notificationMessage;
                var tab = $('[data-id="' + field + '"]').closest('.panel-collapse');

                if (tab.length > 0) {
                    tab.parent().find('.panel-heading').attr('error', 'error');
                }
            } else {
                globalNotification = true;
            }
            message = notificationMessage;
            $scope.$apply();
        } else {
            message = notification.message;
        }

        return {
            global: globalNotification,
            errorMessage: message,
        };
    };

    const jumpMapperSpecialCases = {
        // monitoring
        "routing-table": "routingTable",
        "events-discovery": "events",
        // account
        "customApplications": "settings;CustomApplications",
        "categories": "settings;Categories",
        "logins": "users",
        "globalAccountConfiguration": "topology",
        "alertRules": "settings;HealthRules",
        "bwManagement": "settings;BandwidthManagement",
        // access
        "cloudAccessSettings": "settings;BrowserAccess",
        "singleSignOn": "settings;SingleSignOn",
        // security
        "internetFW": "firewall",
        "wanFW": "wanFirewall",
        "threatProtectionConfiguration": "settings;IpsPolicy",
        // analytics
        "monitorURLs": "usage",
        "monitorCategories": "usage",
        "monitorDomains": "usage",
        "monitorApps": "usage",
        "monitorLogin": "users",
        "monitor": "sites",
        // global configuration
        // administration
        "loginSettings": "settings;LoginRestrictions",
        "license": "settings;License",
        "systemSettings": "settings;SystemSettings",
        "apiKeysManagement": "ApiManagement",
    }

    function redirectToUrl(target) {
        console.log(`changing fe from [${window?.location?.href}] to [${target}]`);
        store.action({
            path: '/switchToNewFrontEnd',
            queryParams: {
                sourceURL: window?.location?.href,
                targetURL: target
            },
            success: function (data) {
            },
        });

        window.location.href = target;
    }

    const jumpToAmazingUi = function() {
        const re = /(?<schema>http[s]*)\:\/\/(?<subdomain>[\w-]+).(?<service>[\w]+).(?<domain>[\w\.]+)\/\#\!\/(?<accountId>[\d]+)\/(?<page>[\w-]+)[\?]?(?<queryParams>.*)/;

        const { groups } = re.exec(window.location.href) || {};
        const page = jumpMapperSpecialCases[groups?.page || ""] || groups?.page;
        if (!page || page === "_") {
            console.log(`not changing fe because of missing route for ${groups?.page}`);
            return;
        }
        if (groups?.subdomain == "cc2") {
            console.log(`not changing fe because not browsing with subdomain`);
            return;
        }
        let target = `${groups?.schema}://${groups?.subdomain}.cc.${groups?.domain}/?#/account/${groups?.accountId}/${page}`;
        if (!groups?.queryParams || !groups?.page || !(["monitor", "monitorLogin"].includes(groups.page))) {
            redirectToUrl(target);
        }

        /** if we're in site/user monitor statistics page, we want to navigate to the matching stats page in the new FE */

        // handle filter in ULR query param
        // this part is URI encoded so we handle it with
        let protoId = undefined;
        let type = undefined;
        const queryParamsArr = groups?.queryParams.split("&") || [];
        const filter = queryParamsArr.find(x => x.includes("filter="));

        try {
            if (!!filter) {
                const decodedFilterPart = JSON.parse(decodeURIComponent(filter).replace("filter=",""));
                protoId = decodedFilterPart?.pid;
                type = decodedFilterPart?.type;
            }
        } catch (e) {
            // if we fail to get proto ID and type from the URL - we'll navigate to the general page
        }

        if ((!!protoId || protoId === 0) && type && groups?.page && (groups?.page === "monitor" || groups?.page === "monitorLogin")) {
            store.fetch({
                path: `/getByProtoID?accountId=${groups?.accountId}&protoId=${protoId}&type=${type}`,
                success: function(data) {
                    let subPage = "";
                    if (data.status === "OK") {
                        const dbId = data.notifications[0].message;
                        const pageByType = (type === "site") ? "stats" : "usage";
                        subPage = `/${dbId}/${pageByType}`;
                    }
                    target = target + subPage;
                    redirectToUrl(target);
                },
            });
        } else {
            redirectToUrl(target);
        }
    }

    $rootScope.saveChoiceAndJumpToAmazingUi = function() {
        jumpToAmazingUi();
    }

    $rootScope.amazeMe = function() {
        $rootScope.confirm(
            $sce.trustAsHtml(`<p>After clicking the “SWITCH TO THE NEW USER INTERFACE” button, you will be redirected to your account in the new system, all your data is already there.</p>`),
            () => {
                // $rootScope.saveChoiceAndJumpToAmazingUi();
                jumpToAmazingUi();
            },
            "Switch to the new user Interface",
            "Cancel",
            () => {},
            "",
            false,
            true,
            'Get ready to be amazed !!'
            )
    }

    $rootScope.copyUrlWithSubdomain = function() {
        $timeout(function () {
            const loc = window.location.href;
            const sbdStart = loc.indexOf('://') + 3;
            const sbdEnd = loc.indexOf('.');
            const locToCopy = loc.substring(0, sbdStart) + $rootScope.fqdn.toLowerCase() + loc.substring(sbdEnd);
            CopyToClipboardService.copy(locToCopy);
        }, 0);
    };

    $rootScope.clearErrors = function () {
        $rootScope.errors = {};
        $rootScope.errorsNum = 0;
        $('.panel-heading').removeAttr('error');
    };

    $rootScope.handleServerResponse = function (response, type, message, onSuccess, noChange) {
        var notificationType = 'success';
        var title = '';
        var error;
        var isError = (response.status == 'ERROR');
        var showGlobalNotification = false;
        $rootScope.errorsNum = 0;
        $rootScope.clearErrors();

        if (response.redirectTo) {
            var newLocation = response.redirectTo
            if (GeneralUtilsService.getParams($location) !== "") {
                newLocation = newLocation + '?data=' + GeneralUtilsService.getParams($location);
            }
            document.location.href = newLocation;
            return;
        }

        if (isError) {
            notificationType = 'error';
            for (var key in response.notifications) {
                error = $scope.getError(response.notifications[key], type);
                showGlobalNotification = error.global;
            }
            message = error.errorMessage;
        } else {
            if (!noChange) {
                $rootScope.userEdited = true;
                $rootScope.progressDone = 0;
            }
            showGlobalNotification = true;
            if (onSuccess) {
                onSuccess();
            }
        }
        if (showGlobalNotification) {
            if(!message){
                for (var key in response.notifications) {
                    message = response.notifications[key].message;
                }
            }
            $rootScope.showNotification(notificationType, message, title, isError);
        }

        $scope.updateErrorsCount();
    };

    $rootScope.showNotification = function (notificationType, message, title, isError, sticky) {
        $rootScope.globalNotification = { type: notificationType, message: message, title: title, sticky: sticky };
        $rootScope.$emit(isError ? '$saveFail' : '$saveSuccess');
    };

    $rootScope.hideNotification = function () {
        $rootScope.$emit('$hideNotification');
    };

    $scope.camelCaseToWords = function (camelCase) {
        return camelCase
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, function (str) { return str.toUpperCase(); });
    };

    $scope.getCurrent = function () {
        /* var modelKey;
         var modelId;*/

        /*  angular.forEach($location.search(), function(value, key) {
         if(key.indexOf("Id") > 0 && key.indexOf("root_") != 0){
         modelKey = key;
         modelId = value;
         return {"modelKey":modelKey,"modelId":modelId};
         }
         });*/
        return { modelKey: $state.params.model, modelId: $state.params.id };
    };

    $scope.asJson = function (model) {
        return angular.toJson(model).replace('"editMode":true:""').replace('"editMode":false:""');
    };

    $scope.toggleSelection = function (arr, item) {
        GeneralUtilsService.toggleSelection(arr, item);
    };

    $scope.disable = function (selectedObjects, type, enable, callback) {
        var selectedItems = [];
        var nameList = [];
        selectedObjects.forEach(function (object) {
            selectedItems.push(object.id);
            if (object.name) {
                nameList.push(object.name);
            }
        });
        var data = { items: selectedItems, type: type };
        var typeName = (type == 'Site' ? 'site' : 'user');
        var len = selectedItems.length;
        var action = enable ? 'enable' : 'disable';
        if (len == 0) {
            $rootScope.alert('Please select ' + typeName + 's to ' + action);
            return;
        }
        var itemsMessage = (len == 1 ? 'the ' + typeName : len + ' ' + typeName + 's');
        itemsMessage = action + ' ' + itemsMessage;

        if (nameList.length > 0) {
            if (nameList.length > 1) {
                itemsMessage += ': ';
            } else {
                itemsMessage += ' ';
            }
            itemsMessage += nameList.join(', ');
        }

        $rootScope.confirm('Are you sure you want to ' + itemsMessage + '?', function () {
            store.save({
                path: 'disable',
                method: 'POST',
                data: data,
                dataObj: 'json',
                queryParams: {
                    enable: enable,
                    accountId: $state.params.accountId,
                },
                success: function (data) {
                    $rootScope.handleServerResponse(data, typeName, typeName + 's ' + action + 'd successfully');
                    if (data.status != 'ERROR') {
                        selectedObjects.forEach(function (object) {
                            if (data.data.newStatus && data.data.newStatus[object.id]) {
                                object.status = data.data.newStatus[object.id];
                                if (callback) callback(object);
                                if ($scope.orig) {
                                    $scope.orig.status = object.status;
                                }
                            }
                        });
                        $scope.$digest();
                    }
                },
            });
        });
    };


    function showHover($target, text, popup, type) {
        var $window = $(window);
        var $toolTopEl = $('.' + popup + '-popup').first();
        $toolTopEl.css('visibility', 'hidden');

        var classList = $toolTopEl.attr('class').split(/\s+/);
        for (var i = 0;classList[i];i++) {
            if (classList[i].indexOf('type-') === 0) {
                $toolTopEl.removeClass(classList[i]);
                break;
            }
        }

        if (type) {
            $toolTopEl.addClass('type-' + type);
        }

        (function () {
            var drawPromise = $q.defer();

            $scope.$apply(function () {
                $rootScope[popup] = type || true;
                var $tooltipContent = $toolTopEl.find('.tooltip-content');

                if ($tooltipContent.length > 0) {
                    $tooltipContent.text(text);
                } else {
                    $toolTopEl.text(text);
                }
                drawPromise.resolve();
            });

            return drawPromise.promise;
        }()).then(function () {
            $timeout(function () {
                var position = $target.offset();
                var $tooltipInner = $toolTopEl.find('.tooltip-inner');
                $tooltipInner.css('height', 'auto');
                $tooltipInner.clearQueue();

                $toolTopEl.css({
                    right: Math.max($window.width() - position.left - ($target.outerWidth() / 2) - ($toolTopEl.outerWidth() / 2), 0),
                    bottom: $window.height() - position.top
                });

                var shouldBreakWord = $target.attr('break-word');
                var $tooltipContent = $toolTopEl.find('.tooltip-content');
                if (shouldBreakWord)
                    $tooltipContent.css('word-wrap', 'break-word');
                else
                    $tooltipContent.css('word-wrap', 'normal');

                var neededHeight = $toolTopEl.height();
                $tooltipInner.css('height', 0);

                $toolTopEl.css('visibility', 'visible');
                $tooltipInner.animate({'height': neededHeight}, 200);
            }, 0, false);
        });
    }

    $scope.updateErrorsCount = function () {
        var counter = 0;
        for (var key in $rootScope.errors) {
            counter++;
        }
        $rootScope.errorsNum = counter;
        $scope.$digest();
    };


    angular.element(document).ready(function () {
        $scope.baseReady = true;
        $scope.baseInit();
        $scope.setDrawers();
    });

    $rootScope.$on('$viewContentLoaded', function (event, view) {
        checkPageLoad(event.currentScope, event.targetScope);

        clearHoverHandlers();
        setHoverHandlers();
    });

    $transitions.onSuccess({}, function(transition) {
        var current = transition.to();
        var toParams = transition.params('to');

        var loc = $location.path();
        var paths = loc.split('/');

        if (paths.length > 0) {
            var re = new RegExp('\d+');
            if (re.exec(paths[1]) >= 0) {
                loc = '/' + paths.slice(2).join('/');
            }
        }


        if (shouldSendStats) {
            // send page to Google Analytics
            ga('set', 'page', loc);
            ga('set', 'dimension1', toParams.accountId ? toParams.accountId : 'none');
            ga('set', 'dimension2', toParams.curtab ? toParams.curtab : (current.defaultCurtab ? current.defaultCurtab : 'none'));
            ga('send', 'pageview');
        }

    });

    var pageReadyTimeout;

    var checkPageLoad = function (currentScope, targetScope) {
        if ((!$scope.pageReady || !$scope.baseReady) && !$scope.pageInit) {
            if (pageReadyTimeout) {
                $timeout.cancel(pageReadyTimeout);
            }

            pageReadyTimeout = $timeout(function () {
                if ((!$scope.pageReady || !$scope.baseReady) && !$scope.pageInit) {
                    if ($scope.init) {
                        $scope.init();
                    }
                    $scope.baseInit();
                    $scope.pageInit = true;
                    if (AmCharts) {
                        AmCharts.handleLoad();
                    }
                    pageReadyTimeout = null;
                }
            }, 50, false);
        }
    };

    $scope.baseInit = function () {

        $scope.adminName = UserContextService.getAdminName();
        $scope.userInitials = $scope.adminName.first.substr(0, 1).toUpperCase() + $scope.adminName.last.substr(0, 1).toUpperCase();

        if (typeof $.material !== 'undefined' && $.material) {
            $.material.init();
        }

        if (typeof svg4everybody !== 'undefined' && svg4everybody) {
            svg4everybody();
        }
    };

    $rootScope.closeAllPopups = function () {
        if ($scope.openedPopover.popup) {
            $scope.openedPopover.popup.hide();
            $scope.openedPopover = { popup: null, invoker: null };
        }

        if ($scope.openedPopup) {
            if ($scope.openedPopup.hasClass('modal')) {
                $scope.openedPopup.modal('hide');
            } else {
                $scope.openedPopup.hide();
            }
            $scope.openedPopup = null;
        }

        if ($rootScope) {
            $rootScope.tooltip = null;
            $rootScope.ellipses = null;
        }
    };


    $rootScope.updateScroll = function (selector) {
        $timeout(function () {
            selector = selector || '.nano';

            $(selector + ':not(.has-scrollbar)').nanoScroller({
                alwaysVisible: true,
            });

            $(selector).nanoScroller('update');
        }, 0, false);
    };

    $rootScope.openedPopup = null;

    if (!$scope.openedPopover) {
        $scope.openedPopover = { popup: null, invoker: null };
    }

    $rootScope.$on('$togglePopup', function (event, popup, invokerId, options) {
        if ($scope.openedPopover && $scope.openedPopover.popup === $('#' + popup))   {
            $rootScope.$emit('$closePopup', popup);
        } else {
            $rootScope.$emit('$openPopup', popup, invokerId, options);
        }
    });

    $rootScope.$on('$openPopup', function (event, popup, invokerId, options) {
        if ($scope.openedPopup && !$scope.openedPopup.hasClass('modal')) {
            $scope.openedPopup.hide();
        }

        options = options || {};
        var $window = $(window);
        var $invoker = $('#' + ($filter('removeSpecialChars')(invokerId)));
        var position = options.simplePosition ? $invoker.position() : $invoker.offset();
        var topMod = options.topMod || -60;
        var leftMod = options.leftMod || ($rootScope.menuClosed ? -71 : -230);
        var yPosition = position.top;
        var xPosition = position.left;

        var $popup = $('#' + popup);
        if (!options.lockDown && yPosition > ($window.height() * (2 / 3))) {
            // open on top
            topMod -= $popup.outerHeight();
            topMod -= $invoker.outerHeight();
            $popup.removeClass('bottom bottom-left');
            $popup.addClass('top top-left');
        } else {
            $popup.removeClass('top top-left');
            $popup.addClass('bottom bottom-left');
        }
        if (xPosition + $popup.outerWidth() + 25 > ($window.width())) {
            // open on left
            options.rightArrow = true;
            leftMod -= $popup.outerWidth();
        }

        if (options.offset) {
            xPosition -= ($popup.width() / 2);
            $popup.removeClass('bottom-left');
            $popup.removeClass('top top-left');
            $popup.addClass('bottom');
        }

        if (options.absolute) {
            yPosition = 60;
            topMod = 0;
            leftMod += ($invoker.width() / 2);
        }

        yPosition += topMod;
        xPosition += leftMod;
        $popup.css({ top: yPosition, left: xPosition });

        $popup.clearQueue();
        $popup.fadeIn(100, function () {
            $scope.openedPopover = { popup: $popup, invoker: invokerId };
        });

        var $arrowEl = $popup.find('.arrow');
        $arrowEl.css({ left: (options.rightArrow ? $popup.width() - 20 : 15) });
    });

    $rootScope.$on('$closePopup', function (event, popup) {
        $('#' + popup).fadeOut(100);
        $scope.openedPopover = { popup: null, invoker: null };
    });

    $rootScope.openPopup = function (name, e) {
        if ($scope.openedPopup) {
            $scope.openedPopup.modal('hide');
        }
        var $targetPopup = $('#' + name);
        if ($targetPopup.hasClass('modal')) {
            $targetPopup.modal('show');
        } else {
            $targetPopup.show();
        }

        $timeout(function () {
            $scope.openedPopup = $targetPopup;
        }, 10, false);
    };

    $rootScope.closePopup = function (name) {
        var $targetPopup = $('#' + name);
        if ($targetPopup.hasClass('modal')) {
            $targetPopup.modal('hide');
        } else {
            $targetPopup.hide();
        }

        $scope.openedPopup = null;
    };

    $rootScope.openDropDown = function (name, e) {
        if ($scope.openedPopup) {
            $scope.openedPopup.hide();
        }

        var $targetPopup = $('#' + name);
        $targetPopup.show();

        $timeout(function () {
            $scope.openedPopup = $targetPopup;
        }, 10, false);
    };

    $rootScope.closeDropDown = function (name) {
        $('#' + name).hide();
        $scope.openedPopup = null;
    };

    $rootScope.toggleDropDown = function (elId, $event) {
        if (document.getElementById(elId).style.display === 'block') {
            $rootScope.closeDropDown(elId);
        } else {
            $rootScope.openDropDown(elId, $event);
        }
    };

    //ATTENTION!!!! WHEN USING parseAsHtml NO VALUES BUILT FROM USER INPUT ARE ALLOWED IN message, BECAUSE IT IS HUGE SECURITY RISK.
    $rootScope.confirm = function (message, onConfirm, ok, cancel, onCancel, checkbox, waitForModalHide, parseAsHtml, title) {
        $rootScope.confirmData = {
            message: message,
            ok: ok || 'OK',
            cancel: cancel || 'Cancel',
            onConfirm: onConfirm,
            onCancel: onCancel,
            checkbox: checkbox,
            waitForModalHide: waitForModalHide,
            //ATTENTION!!!! WHEN USING parseAsHtml NO VALUES BUILT FROM USER INPUT ARE ALLOWED IN message, BECAUSE IT IS HUGE SECURITY RISK.
            parseAsHtml: parseAsHtml || false,
            title: title
        };
        if ($scope.openedPopup) {
            $scope.openedPopup.modal('hide');
        }

        var $targetPopup = $('#confirm');
        $targetPopup.modal('show');

        $timeout(function () {
            $scope.openedPopup = $targetPopup;
        }, 10, false);

        $timeout(function () {},0);
    };

    $rootScope.alert = function (message, ok, onConfirm, checkbox) {
        $rootScope.confirmData = {
            message: message,
            ok: ok || 'OK',
            checkbox: checkbox,
            onConfirm: onConfirm,
        };

        if ($scope.openedPopup) {
            $scope.openedPopup.modal('hide');
        }

        var $targetPopup = $('#confirm');
        $targetPopup.modal('show');

        $timeout(function () {
            $scope.openedPopup = $targetPopup;
        }, 10, false);

        $timeout(function () {},0);
    };


    $rootScope.confirmOK = function () {
        $('#confirm').modal('hide');
        $scope.openedPopup = null;

        if ($rootScope.confirmData.onConfirm) {
            if($rootScope.confirmData.waitForModalHide) {
                $('#confirm').on('hidden.bs.modal',onConfirmOnce);
            }
            else {
                $rootScope.confirmData.onConfirm();
                $rootScope.confirmData = null;
            }
        }
    };

    $rootScope.confirmCancel = function () {
        $('#confirm').modal('hide');
        $scope.openedPopup = null;

        if ($rootScope.confirmData && $rootScope.confirmData.onCancel) {
            if($rootScope.confirmData.waitForModalHide) {
                 $('#confirm').on('hidden.bs.modal', onCancelOnce);
            }
            else {
                $rootScope.confirmData.onCancel();
                $rootScope.confirmData = null;
            }
        }
    };

    //unsubscribe from hide modal event to avoid running onConfirm again for another modal
    var onConfirmOnce = function() {
        $('#confirm').off('hidden.bs.modal', onConfirmOnce);
        $rootScope.confirmData.onConfirm();
    };

    //unsubscribe from hide modal event to avoid running onCancel again for another modal
    var onCancelOnce = function() {
        $('#confirm').off('hidden.bs.modal', onCancelOnce);
         $rootScope.confirmData.onCancel();
    };



    $('body').click(function (evt) {
        var $target = $(evt.target);

        if ($scope.openedPopup && $target.parents('.modal-dialog').length == 0) {
            if ($scope.openedPopup?.hasClass('modal')) {
                $scope.openedPopup?.modal('hide');
            } else {
                $scope.openedPopup?.hide();
            }

            $scope.openedPopup = null;
            // This is used to catch the event when a popup is closed without pressing the 'X' or 'close/cancel' button
            $rootScope.$broadcast('$reset-popup-params');

            if ($rootScope.confirmData && $rootScope.confirmData.onCancel) {
                $rootScope.confirmData.onCancel();
            }
        }

        if ($scope.openedPopover.popup && $target.parents('.popover').length == 0) {
            $scope.openedPopover.popup.hide();
            $scope.openedPopover = { popup: null, invoker: null };
        }

        for (var drawerKey in $rootScope.drawers) {
            var drawer = $rootScope.drawers[drawerKey];
            if (drawer.open && $target.parents('.drawer').length === 0 &&
                $target.parents('.drawer-button').length === 0 && $target.parents('.modal-dialog').length == 0
                && !$target.hasClass('drawer-button')) {
                drawer.open = false;
                drawer.$el.clearQueue();
                drawer.$el.animate({
                    width: 0,
                });
            }
        }

        if (!$target.hasClass('allow-date-picker') && $target.parents('.daterangepicker').length === 0 && !$target.hasClass('datetimepicker')
            && $target.parents('.datetimepicker').length === 0 && $target.parents('.calendar-date').length === 0) {

            $('.daterangepicker').each(function (i, datepicker) {
                var $datepicker = $(datepicker);
                if ($datepicker.css('display') === 'block') {
                    $datepicker.find('button.cancelBtn').click();
                }
            });
        }
    });

    $(document).keydown(function(e) {
        if ($rootScope) {
            if ($scope.openedPopup) {
                if (e.keyCode == 27) {
                    if ($rootScope.confirmData) {
                        $rootScope.confirmCancel();
                    }
                    $rootScope.closeAllPopups();
                }

                if (e.keyCode == 13) {
                    if ($rootScope.confirmData) {
                        $rootScope.confirmOK();
                    } else {
                        if ($scope.openedPopup.hasClass('modal')) {
                            var $saveButton = $scope.openedPopup.find('.btn-save');
                            if ($saveButton.length === 1) {
                                $scope.openedPopup.find('.btn-save').click();
                            }
                        }
                    }
                }
            }
        }
    });

    $scope.setDrawers = function() {
        $rootScope.drawers = {
            notifications: { $el: null, open: false, width: 325},
            documentation: { $el: null, open: false, width: 600, relative: true  },
        };

        $rootScope.toggleDrawer = function (type) {
            if (!$rootScope.drawers[type].$el) {
                $rootScope.drawers[type].$el = $('.drawer.' + type + '-drawer');
            }

            $rootScope.drawers[type].$el.clearQueue();
            if ($rootScope.drawers[type].open) {
                $rootScope.drawers[type].open = false;
                $rootScope.drawers[type].$el.animate({
                    width: 0,
                });
            } else {
                var targetWidth = $rootScope.drawers[type].width;
                if ($rootScope.drawers[type].relative) {
                    var winWidth = $(window).width();
                    if (winWidth <= 900) {
                        targetWidth -= 200;
                    } else if (winWidth <= 1280) {
                        targetWidth -= 100;
                    }
                }

                $rootScope.drawers[type].open = true;
                $rootScope.drawers[type].$el.animate({
                    width: targetWidth + 'px',
                });
            }
        };
    };

    // this flag is here for easy rollback
    $rootScope.retireMonitorStats = true;

    // saved in the base controller so that it won't be reset each time the page refresh (we could also save it to sessionStorage)
    $scope.usageStatsNewUIModalsDismissed = {
        apps: false,
        domains: false,
        sites: false,
        hosts: false,
        categories: false
    }

    $rootScope.dismissNewUIModals = function(type) {
        $scope.usageStatsNewUIModalsDismissed[type] = true;
    }

    $rootScope.isNewUIModalDismissed = function(type) {
        return $scope.usageStatsNewUIModalsDismissed[type];
    }
}

